module.exports = __webpack_public_path__ + "img/header.f768587a.png";